import './polyfills';
import React, { Suspense, lazy } from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { iTradeEnv } from '@/configurations/app-configs/iTrade.env'
import { store } from './configurations'
import * as serviceWorker from './service.worker';
import { getWebSetting, getDeviceInfo } from './actions/app';
import { checkAuthAction , checkRunMode} from './actions/auth';
import { ConfigActions } from './actions/trading';
import Spinner from './components/Spinner/LoadingSpinner';
import { isMobile, detectBrowsers, geolocationCall } from './helpers/global';

import './index.scss';

const LazyApp = lazy(() => import('./App'));
store.dispatch(checkRunMode())
store.dispatch(checkAuthAction());
store.dispatch(getDeviceInfo(isMobile(), detectBrowsers(), geolocationCall()));
store.dispatch(getWebSetting());
store.dispatch(ConfigActions.getConfigSettingsAction({}))
/**
 * If you want to enable logs set it to `true`
 */
window.isLoggingEnabled = false;

class WebApp extends React.Component {
    constructor(props) {
        super(props)
    }

    render() {
        return (
            <Provider store={store}>
                <Suspense fallback={<Spinner />}>
                    <LazyApp />
                </Suspense>
            </Provider>
        )
    }
}

const rootElement = document.getElementById('root');
ReactDOM.render(<WebApp />, rootElement);
serviceWorker.unregister();